module.exports = __webpack_public_path__ + "static/media/edsiderlogowhite.f082f3b1.png";